import { ChampionIcon, FireIcon, ShopSignIcon } from '@hugeicons/react'
import clsx from 'clsx'

type FeaturedListCardStripTone =
  | 'mission'
  | 'quiz'
  | 'prize'
  | 'partner'
  /** Item da lojinha retirado no estande do parceiro, não no ponto central. */
  | 'booth'

const TONE_CLASS: Record<FeaturedListCardStripTone, string> = {
  mission: 'bg-warning-light text-warning-text',
  quiz: 'bg-warning-light text-warning-text',
  prize: 'bg-warning-light text-warning-text',
  partner: 'bg-brand-light text-brand',
  booth: 'bg-brand-light text-brand'
}

const TONE_ICON: Record<FeaturedListCardStripTone, typeof FireIcon> = {
  mission: FireIcon,
  quiz: FireIcon,
  prize: FireIcon,
  partner: ChampionIcon,
  booth: ShopSignIcon
}

const FEATURED_CARD_AMBER_SURFACE = clsx(
  /* `!` vence `border-contour` do Card base — sem isso a borda lia cinza. */
  '!border-2 !border-featured-amber-border',
  'bg-gradient-to-br from-orange-50/90 to-white',
  'shadow-[0_4px_16px_var(--color-featured-amber-shadow)]'
)

const FEATURED_CARD_PARTNER_SURFACE = clsx(
  '!border-2 !border-featured-partner-border',
  'bg-gradient-to-br from-featured-partner-surface-from to-white',
  'shadow-[0_4px_16px_var(--color-featured-partner-shadow)]'
)

/** Borda + fundo + sombra — âmbar (missões/quizzes/prêmios) ou roxo (parceiros e estande). */
export const featuredListCardClassName = (
  tone: FeaturedListCardStripTone
): string =>
  tone === 'partner' || tone === 'booth'
    ? FEATURED_CARD_PARTNER_SURFACE
    : FEATURED_CARD_AMBER_SURFACE

type FeaturedListCardStripProps = {
  label: string
  tone?: FeaturedListCardStripTone
  className?: string
  /** Versão reduzida para cards estreitos (ex.: mini grid na home). */
  compact?: boolean
}

/** Faixa full-bleed no topo do card — destaque sem aumentar altura do corpo. */
export function FeaturedListCardStrip({
  label,
  tone = 'mission',
  className,
  compact = false
}: FeaturedListCardStripProps) {
  const Icon = TONE_ICON[tone]

  return (
    <div
      className={clsx(
        'flex w-full items-center justify-center font-bold uppercase',
        compact
          ? 'gap-0.5 whitespace-nowrap px-1 py-0 text-[0.5625rem] leading-none tracking-normal'
          : 'gap-1.5 px-3 py-1.5 text-caps tracking-wide',
        TONE_CLASS[tone],
        className
      )}
    >
      <Icon size={compact ? 9 : 12} variant="solid" aria-hidden />
      {label}
    </div>
  )
}
